import getBrowser from './browser'
export default {
  /**
   * Get Browser Information
   */
  get getBrowser() {
    return getBrowser()
  },
}
